//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import configInfo from "../../configInfo.js"
  import {loader} from '../../js/loader'
  import matchSimplePublicIndex from '../league/matchSimple_publicIndex.vue'
  export default{
      data(){
          return{
              leagueInfos:[],
              indexContentHeight:''
          }
      },
      mounted(){
          this.getData();
      },
    methods:{
          getData(){
            this.$vux.loading.show();
            this.hagkHttp(this.hagkApi.getHotLeagues(),{}).then(
              (res)=> {
                for(var i = 0;i<res.length;i++){
                  var leagueInfoVo = res[i];
                  var matchs = leagueInfoVo.matches;
                  if(matchs){
                    for(var j = 0;j < matchs.length;j++){
                      var match = matchs[j];
                      if(match.isEnd){
                        match.dispalyScore = this.dispalyScore(match.result);
                      }else{
                          match.score = "vs";
                      }
                    }
                  }
                  this.leagueInfos.push(leagueInfoVo);
                }
              }, (error) => {
                console.log(error);
              }
            );
            this.$vux.loading.hide()
          },
          dispalyScore:function(matchResultVo){
            var goalFor = matchResultVo.goalFor;
            var goalAgainst = matchResultVo.goalAgainst;
            var homeExScore = matchResultVo.homeExScore;
            var visitorExScore = matchResultVo.visitorExScore;
            var homePkScore = matchResultVo.homePkScore;
            var visitorPkScore = matchResultVo.visitorPkScore;
            var homeds = "";
            var visitords = "";
            var homeScore = goalFor + homeExScore;
            homeds =  homeScore+"";
            var visitorScore = goalAgainst + visitorExScore;
            visitords = visitorScore+"";
            if(homePkScore > 0 || visitorPkScore > 0){
              homeds += "("+homePkScore+")";
              visitords += "("+visitorPkScore+")";
            }
            return homeds+"-"+visitords;
          },
        toMatchDetail: function (matchId, homeTeamId, visitTeamId) {
          this.$router.push({
            path: '/match_info',
            query: {
              matchId: matchId,
              homeTeamId: homeTeamId,
              visitTeamId: visitTeamId
            }
          });
        }
    },
    components:{
      matchSimplePublicIndex
    }
  }





// WEBPACK FOOTER //
// ./src/components/publicindex/hot_league.vue